import React from "react";
import { useTranslation } from "react-i18next";

interface TitleProps {
  title?: string;
  model_name: string;
}

const AgentTitle = ({ title, model_name }: TitleProps) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      {title ? (
        <div className="title-container">
          <span>
            <b className="navbar-title-custom">{title}</b>
          </span>
          <span>
            <small className="text-muted">
              {t("pages.home.currentModel")} {model_name}
            </small>
          </span>
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default AgentTitle;
